export const REGEX_PATTERNS = {
  // login reset password, operator create & update, operator change password
  password: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-={}\[\]|\\:;"'<>,.?/~`])[A-Za-z\d!@#$%^&*()_+\-={}\[\]|\\:;"'<>,.?/~`]{8,}$/,
  contain_numbers: /[0-9]/,
  contain_uppercase: /[A-Z]/,
  contain_lowercase: /[a-z]/,
  contain_special_character: /[!@#$%^&*()_+\-={}\[\]|\\:;"'<>,.?/~`]/,
  is_valid_character: /^[A-Za-z\d!@#$%^&*()_+\-={}\[\]|\\:;"'<>,.?\/~`]*$/,
};